// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1DQRh","itemTitle":"ClientEmergencyInfo_itemTitle__3CAfZ","itemText":"ClientEmergencyInfo_itemText__qeJip"};